import { render, staticRenderFns } from "./WAREHOUSING.vue?vue&type=template&id=198ad340&"
import script from "./WAREHOUSING.vue?vue&type=script&lang=js&"
export * from "./WAREHOUSING.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports